import moment from 'moment';
import last from 'lodash/last';
import initial from 'lodash/initial';
import { fromJS, Map } from 'immutable';

export const initialDocument = () => {
  return {
    id: null,
    name: '',
    category: 1,
    extension: null,
    wellbore: { id: null },
    created: null,
    modified: null,
  };
};

export const toFileFromDTO = ({
  fileId,
  externalId,
  name,
  category,
  wellboreId,
  extension,
  created,
  modified,
  taskId,
  fullName,
  createdByUserId,
  categoryName,
  projectId,
}) => {
  return fromJS({
    id: fileId,
    name: name,
    category: category,
    extension: extension,
    wellbore: { id: wellboreId },
    created: moment(created),
    modified: modified,
    taskId: taskId,
    fullName: fullName,
    createdByUserId,
    fileId,
    categoryName,
    projectId,
    externalId,
  });
};

const initialMetaFromFilename = ({ name }, initialCategory) => {
  const parts = name.split('.');

  return Map({
    name: initial(parts).join('.'),
    category: initialCategory.id,
    extension: `.${last(parts)}`,
  });
};

const wellboreFileMappers = {
  WellboreFile: {
    initial: initialDocument,
    from: toFileFromDTO,
    Meta: {
      initial: initialMetaFromFilename,
    },
  },
  toFileFromDTO,
  initialDocument,
};

export default wellboreFileMappers;
